<template>
  <div>
    <section class="bg-white">
      <div class="container lg:w-4/5">
        <h1 class="text-center font-semibold text-4xl mb-base" style="color: #3089f0;">My Library</h1>
        <vs-tabs color="#3089f0" alignment="center" v-model="currentTabIndex">
          <vs-tab label="Microlearning"  >
            <div class="flex justify-between items-center">
              <div class="flex justify-start mt-2 mb-2 items-center">
                <p class="font-bold">Filter by</p>
                <CheckboxDropdown
                  class="p-2"
                  label="Language"
                  field="languageKey"
                  v-model="activeFilters"
                  :options="$options.languageTypes"
                />
                <CheckboxDropdown
                  class="p-2"
                  label="Learning Format"
                  field="category"
                  v-model="activeFilters"
                  :options="$options.formatOptions"
                />
                <CheckboxDropdown
                  class="p-2"
                  label="Duration"
                  field="durationType"
                  v-model="activeFilters"
                  :options="$options.durationTypes"
                />

                <CheckboxCompetencyDropdown
                  class="p-2"
                  label="Personality"
                  field="GBCharacteristic"
                  v-model="activeFilters"
                  :options="$options.GBCharacteristic"
                />
              </div>
              <vs-button
                type="filled"
                color="#3089f0"
                :disabled="!selectedCoursesList.length > 0"
                @click="showDistributeModal = true"
                >Distribute</vs-button
              >
            </div>
            <div class="flex  mb-1">
              <p v-show="activeFilters.length > 0" class="font-semibold">
                Active Filters :
              </p>
              <p>
                <vs-chip
                  v-for="(item, idx) in activeFilters"
                  :key="idx"
                  class="mx-1"
                  closable
                  @click="removeFilter(item)"
                >
                  {{ item.value }}
                </vs-chip>
              </p>
              <vx-tooltip
                class="mr-4"
                text="Clear All"
                position="center"
              ><vs-button
                id="pi-step-0"
                v-show="activeFilters.length > 0"
                @click="activeFilters = []"
                class="text-danger"
                style="height:35px;z-index: 0"
                size="small"
                color="primary"
                type="flat"
                icon-pack="material-icons"
                icon="settings_backup_restore"
              ></vs-button
              ></vx-tooltip>
            </div>
            <div
              class="flex flex-wrap -m-3 mb-base vs-con-loading__container"
              id="library-load-more"
            >
              <template v-for="(trainingItem, idx) in trainingItemList">
                <div class="lg:w-1/3 p-3 sm:w-1/2 w-full relative" :key="idx">
                  <vs-checkbox
                    color="#3089f0"
                    class="select-course-checkbox"
                    :ref="`checkbox-${idx}`"

                    v-model="selectedCoursesList"
                    :vs-value="trainingItem"
                  >
                  </vs-checkbox>
                  <LibraryItemCard
                    :item="trainingItem"
                    @selected="selectCourse(idx)"
                    layout="portrait"
                  />
                </div>
              </template>
<!--              <template v-if="totalTrainingItems === 0">-->
<!--                <div class="not-found-message">-->
<!--                  <h4>-->
<!--                    Sorry. We couldn't find a Learning Module quite like that-->
<!--                  </h4>-->
<!--                </div>-->
<!--              </template>-->
            </div>
            <div class="" v-if="totalTrainingItems > 15">
              <vs-pagination
                color="#3089f0"
                :total="totalLearningPages"
                v-model="learningItemPageNumber"
              ></vs-pagination>
            </div>
          </vs-tab>
<!--          <vs-tab label="Microcredits">-->
<!--            <div-->
<!--              class="flex flex-wrap -m-3 mb-base vs-con-loading__container"-->
<!--              id="library-load-more"-->
<!--            >-->
<!--              <template v-for="(testItem, idx) in testItemList">-->
<!--                <div class="lg:w-1/3 p-3 sm:w-1/2 w-full" :key="idx">-->
<!--                  <LibraryItemCard-->
<!--                    :item="testItem"-->
<!--                    :isTestItem="true"-->
<!--                    layout="portrait"-->
<!--                  />-->
<!--                </div>-->
<!--              </template>-->
<!--            </div>-->
<!--            <div class="" v-if="totalTestItems > 15">-->
<!--              <vs-pagination-->
<!--                color="danger"-->
<!--                :total="totalTestPages"-->
<!--                v-model="testItemPageNumber"-->
<!--              ></vs-pagination>-->
<!--            </div>-->
<!--          </vs-tab>-->
        </vs-tabs>
      </div>
    </section>
    <DistributeCoursesModal
      :courseList="selectedCoursesList"
      :active.sync="showDistributeModal"
    />
  </div>
</template>
<script>
import CheckboxDropdown from "./components/CheckboxDropdown";
import CheckboxCompetencyDropdown from "./components/CheckboxCompetencyDropdown";
import LibraryItemCard from "./components/LibraryItemCard";
import DistributeCoursesModal from "./components/DistributeCoursesModal";
import { formatOptions, durationTypes,languageTypes,GBCharacteristic } from "@/assets/data/journey";

export default {
  name: "Header",
  components: {
    CheckboxDropdown,
    CheckboxCompetencyDropdown,
    LibraryItemCard,
    DistributeCoursesModal,
  },
  formatOptions,
  durationTypes,
  languageTypes,
  GBCharacteristic,
  data() {
    return {
      learningItemPageNumber: 1,
      testItemPageNumber: 1,
      selectedFormat: [],
      selectedDuration: [],
      showDistributeModal: false,
      activeFilters: [],
      selectedSegments: [],
      selectedCoursesList: [],
      currentTabIndex: 0,
      totalTestItems: 0,
      totalTrainingItems: 0,
      loadInProgress: false,
    };
  },
  computed: {
    trainingItemList() {
      return this.$store.state.journey.trainingItemList;
    },
    testItemList() {
      return this.$store.state.journey.testItemList;
    },
    totalLearningPages() {
      return parseInt(
        this.totalTrainingItems % 15 === 0
          ? this.totalTrainingItems / 15
          : this.totalTrainingItems / 15 + 1
      );
    },
    totalTestPages() {
      return parseInt(
        this.totalTestItems % 15 === 0
          ? this.totalTestItems / 15
          : this.totalTestItems / 15 + 1
      );
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
  },
  watch: {
    learningItemPageNumber: function (newVal) {
      window.scrollTo(0, 0);
      this.getTrainingItemList({ skip: 15 * (newVal - 1) });
    },
    testItemPageNumber: function (newVal) {
      window.scrollTo(0, 0);
      this.getTestItemList({ skip: 15 * (newVal - 1) });
    },
    activeFilters: function () {
      this.selectedCoursesList = [];
      this.getTrainingItemList({ skip: 0 });
    },
  },
  mounted() {
    this.getTrainingItemList({ skip: 0 });
    this.getTestItemList({ skip: 0 });
  },
  methods: {
    getTrainingItemList(params) {
      // window.$cookies.set('email',this.$store.state.users.data.email, '3600s');

      /* this.$vs.loading({
        background: "#ffffff",
        container: "#library-load-more",
        color: "danger",
      }); */
      // console.log('hello',this.activeFilters);
      this.$store
        .dispatch("journey/getTrainingItems", {
          items: params.skip,
          lang: this.$i18n.locale.toUpperCase(),
          filters: this.activeFilters,
        })
        .then((res) => {
          this.totalTrainingItems = res.total;
        })
        .finally(() => {
          // this.$vs.loading.close("#library-load-more > .con-vs-loading ");
        });
    },
    getTestItemList(params) {
      /* this.$vs.loading({
        background: "#ffffff",
        container: "#library-load-more",
        color: "danger",
      }); */
      this.$store
        .dispatch("journey/getTestItems", {
          items: params.skip,
          lang: "EN",
        })
        .then((res) => {
          this.totalTestItems = res.total;
        })
        .finally(() => {
          // this.$vs.loading.close("#library-load-more > .con-vs-loading ");
        });
    },
    removeFilter(val) {
      this.activeFilters.splice(this.activeFilters.indexOf(val), 1);
    },
    // used only when selected event is emitted by LibraryItemCard
    selectCourse(idx) {
      if (!this.$refs[`checkbox-${idx}`][0].$el.childNodes[0].checked) {
        this.selectedCoursesList.push(this.trainingItemList[idx]);
      } else {
        this.selectedCoursesList.splice(
          this.selectedCoursesList.indexOf(this.trainingItemList[idx]),
          1
        );
      }
    },
  },
  created() {
    // By Default User Language Filter Start
    // console.log('alexLogin UserData',this.userId)
    this.$store
      .dispatch("journey/fetchDetails", this.$store.state.auth.user._id)
      .then(res=>{
        // console.log('alexLogin UserData new',res.data.primaryLanguage['code'].toUpperCase());

          this.primaryLanguage = res.data.primaryLanguage['code'].toUpperCase();
          if (this.primaryLanguage === 'EN' || this.primaryLanguage === 'PT' || this.primaryLanguage === 'FR' || this.primaryLanguage === 'DE' || this.primaryLanguage === 'ES' || this.primaryLanguage === 'NL' || this.primaryLanguage === 'IT') {
            // console.log('ok');
            this.activeFilters.push({field: 'languageKey', value: this.primaryLanguage});
          } else {
            // console.log('not ok');
            this.activeFilters.push({field: 'languageKey', value: 'EN'});
          }
      })
      .catch((err) => {
        throw err;
      })
      .finally(() => {
        this.$vs.loading.close();
      });

    // By Default User Language Filter End
    const organizationSlug = this.$route.params.organizationSlug;
    if (organizationSlug) {
      this.$store
        .dispatch("organization/fetchOrganizationBySlug", organizationSlug)
        .then((res) => {
          if (!res.data.data[0].activeMarketplace) this.$router.push("/");
          else {
            // console.log('data',res);
            this.$store.dispatch("journey/fetchAlexUser",res.data.data[0]._id ).then(res=>{
              // console.log(res);

            });
          }
        })
        .catch((err) => {
          throw err;
        });
    }
  },

};
</script>
<style scoped>
section {
  padding: 9rem 0;
}
h1 {
  color: #231d4f;
}
.not-found-message {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
/* .con-vs-checkbox >>> span.vs-checkbox {
  position: absolute !important;
  z-index: 1;
  top: 12px;
  left: 12px;
} */

.select-course-checkbox {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1;
}
</style>
